import { getSections } from './helpers.js'

const entity = {
  name: {
    singular: 'Conteúdo',
    plural: 'Conteúdo'
  },
  styles: {
    gridTemplateColumns: '30% 1fr',
    gridTemplateAreas: '"main secondary"'
  },
  collection: 'contents',
  tableHeaders: [
    { text: 'Título', value: 'title' },
    { text: 'Url Amigável', value: 'slug' },
    { text: 'Seção', value: 'sections' },
    { text: 'Actions', value: 'action', sortable: false }
  ],
  model: {
    sections: [],
    slug: '',
    title: '',
    body: '',
    fileTeaser: '',
    summary: '',
    styles: ''
  },
  schema: {
    groups: [
      {
        fields: [
          {
            type: 'checklist',
            label: 'Seções',
            model: 'sections',
            values: getSections()
          },
          {
            type: 'input',
            inputType: 'text',
            label: 'Título',
            model: 'title',
            required: true
          },
          {
            type: 'input',
            inputType: 'text',
            label: 'Resumo',
            model: 'summary',
            required: false
          },
          {
            type: 'input',
            inputType: 'text',
            label: 'Url amigável',
            model: 'slug',
            required: true
          },
          {
            type: 'image',
            label: 'Imagem do Topo',
            model: 'fileTeaser',
            hideInput: true
          }
        ]
      },
      {
        fields: [
          {
            type: 'editor',
            label: 'Conteúdo',
            model: 'body',
            required: false
          },
          {
            type: 'textArea',
            label: 'Estilos',
            model: 'styles',
            required: false,
            rows: 10
          }
        ]
      }
    ]
  },
  formOptions: {
    validateAfterLoad: true,
    validateAfterChanged: true,
    validateAsync: true
  }
}

export default [
  {
    path: '/contents',
    meta: {
      entity,
      requiresAuth: true
    },
    component: () => import(/* webpackChunkName: 'banners' */ '../../components/Crud/CrudList.vue')
  }, {
    path: '/contents/new',
    meta: {
      entity,
      requiresAuth: true
    },
    component: () => import(/* webpackChunkName: 'banners' */ '../../components/Crud/CrudForm.vue')
  }, {
    path: '/contents/:id',
    meta: {
      entity,
      requiresAuth: true
    },
    component: () => import(/* webpackChunkName: 'banners' */ '../../components/Crud/CrudForm.vue')
  }
]
